import React, {PropTypes as T} from 'react';

export default class Checkbox extends React.Component {
  static propTypes = {
    onChange: T.func,
    checked: T.bool,
    children: T.node
  };

  static defaultProps = {
    onChange: Function.prototype,
    checked: false
  };

  handleChange = () => {
    this.props.onChange(!this.props.checked);
  };

  render () {
    return (
      <label className="checkbox">
        <input type="checkbox" onChange={this.handleChange} checked={this.props.checked} />
        <span className="checkbox__tick" />
        <span className="checkbox__label">{this.props.children}</span>
      </label>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/checkbox/index.js